import { createContext, useCallback, useEffect, useState } from 'react'
import { getGroupMembership } from "../users/data/membership";
import { getFavorites, removeFavoriteItem, saveFavoriteItem } from "../users/data/preferences";

const UserContext = createContext()

export const UserContextProvider = ({ uniqueId, koId, name, email, department, userName, userProfile, children }) => {
  const [groupMemberships, setGroupMemberships] = useState([]);

  const loadGroupMemberships = useCallback(async () => {
    const groups = await getGroupMembership({uniqueId}, null)
    setGroupMemberships(groups)
  }, [uniqueId])

  useEffect(() => {
    loadGroupMemberships()
  }, [loadGroupMemberships]);

  /** @param {string|string[]} groupId IDs to match exactly; any match grants membership. */
  const hasGroupIdMembership = (groupId) => {
    const groupIds = Array.isArray(groupId) ? groupId : [groupId]
    return groupMemberships.some((group) => groupIds.includes(group.id))
  }

  const contextValue = {
    uniqueId,
    koId, name, email, department, userName, 
    userProfile,
    groupMemberships,
    hasGroupIdMembership,
    getFavorites,
    saveFavoriteItem,
    removeFavoriteItem
  };

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext